import React, {useState} from 'react';
import * as Icons from 'react-feather';
import {useCore} from "store/core";
import {Loading} from "components/form";
import {Link} from "react-router-dom";

export default function Search(props) {
  const [searchResult, setSearchResult] = useState(false);
  const core = useCore();
  const WAIT_INTERVAL = 1000;
  let timer;

  const handleSearch = (e) => {
     clearTimeout(timer);
     timer = setTimeout(() => {
        core.dispatch(core.getCrmSearch(e.target.value));
     }, WAIT_INTERVAL);
  }

  const TYPES = {
    Movie: "فیلم",
    Serie: "سریال",
    Music: "موزیک",
    SerieEpisode: "قسمتی از سریال",
    Screening: "اکران",
    Physical: "فیزیکی",
    Download: "دانلودی",
 };
  return ( <div className="intro-x relative ml-3 sm:ml-6">
  <div className="search">
     <input type="text"
            onFocus={() => setSearchResult(true)}
            onBlur={() => setSearchResult(false)}
            onChange={handleSearch}
            className="search__input form-control dark:bg-dark-1 border-transparent placeholder-theme-13"
            placeholder="جستجو..."/>
     <Icons.Search className="search__icon dark:text-gray-300"/>
  </div>
  <a className="notification notification--light sm:hidden" href="">
     <Icons.Search/>
  </a>
  <div className={`search-result ${searchResult ? 'show' : ''}`} style={{right:'0',left:'unset'}}>

     <div className="search-result__content">
        {core.crmLoad ? (<Loading/>) : (<>

           {core.crmSearch && core.crmSearch.length > 0 && <>
              <div className="search-result__content__title">نتیجه</div>
              <div className="mb-5">
                 {core.crmSearch.map(item => (
                    <button onClick={()=>{
                      core.dispatch(core.getCrm(item.id));
                      core.dispatch(core.getCrmSearch(''));
                      setSearchResult(false)
                    }} className="flex items-center mt-2">
                       <div className="w-8 h-8 image-fit">
                          <img alt=""
                               className="rounded-full"
                               src={item.avatar || "/images/account.jpg"}/>
                       </div>
                       <div className="mr-3">{item.complete_name}</div>
                     
                    </button>
                 ))}
              </div>
           </>}


        </>)}
     </div>
  </div>
</div>);
}
